// animation for the hero title
const title = document.querySelector('.hero-slider h1');

document.addEventListener("DOMContentLoaded", function(event) {
    setTimeout(() => {
        title.classList.add('ani-title-init');
    }, 100);
});

if (title) {
    // split the title into words and create a staggered effect
    const words = title.textContent.split(' ')
    title.textContent = ''
    words.forEach((word, i) => {
        const span = document.createElement('span')
        span.innerHTML = word
        span.style.animationDelay = `${i * 0.7 + 1}s`
        // add class to each word of active
        span.classList.add('active')
        title.appendChild(span)

    })
}